
module.exports = 'undefined' === typeof WebSocket ? require('ws') : WebSocket



//////////////////
// WEBPACK FOOTER
// ./~/pull-ws/web-socket.js
// module id = 797
// module chunks = 0